import TableTransformEditor from './TableTransformEditor'
export default TableTransformEditor
